export const GoogleMapApiConfig = 'AIzaSyCH5dR8htzajdKr9GeB3mkJYK3AQStH6nk';